import { triggerTracking } from '@zoopla/tracking';
import { authTaxonomyObject } from './constants/taxonomy';
import { trackSegmentAndGAEvent } from '@zoopla/tracking';

export const trackQuestionSkip = (questionName: string, page: string) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory: 'situation',
            eventAction: 'click',
            eventLabel: `${
                page === '/register/' ? '' : 'auth: '
            }${questionName} skip`
        },
        page
    );
};

export const trackQuestionClose = (questionName: string, page: string) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory: 'situation',
            eventAction: 'click',
            eventLabel: `${
                page === '/register/' ? '' : 'auth: '
            }${questionName} close`
        },
        page
    );
};

export const trackFailureEmail = (label = '') => {
    return triggerTracking({
        event: 'GAEvent',
        eventCategory: 'signin',
        eventAction: 'failure_email',
        eventLabel: label
    });
};

export const trackSuccessSignIn = (label = '') => {
    return triggerTracking({
        event: 'GAEvent',
        eventCategory: 'signin',
        eventAction: 'success',
        eventLabel: label,
        taxonomy: authTaxonomyObject.zpg.signin
    });
};

export const trackKeepMeSignedIn = (label = '') => {
    return triggerTracking({
        event: 'GAEvent',
        eventCategory: 'signin',
        eventAction: 'keep_me_signed_in',
        eventLabel: label
    });
};
